module.exports = __webpack_public_path__ + "img/grain.8c4f1682.svg";